@import "../../themes/stories.globals";

:host {
  display: flex;
  position: relative; /*absolute;*/

  flex-direction: column;

  width: 100%;
  height: 100%; /*40px;*/

  contain: layout size style;
  z-index: $z-index-page-container;
}

.tabs-inner {
  position: relative;

  flex: 1;

  contain: layout size style;
}
